import { Button, Link, Typography } from '@mui/material';

import { AuthenticatedPath } from '@shared/constants/routes.constants';
import { BILLING_ADMISSION_MESSAGES } from '@shared/utils/billingAdmissionError';

/** Keep the original task mounted. Recovery never retries a call or assumes a payment succeeded. */
export const BillingAdmissionRecovery = ({ reason }: { reason: string }) => (
  <>
    <Typography component="span" display="block" variant="body2">
      {BILLING_ADMISSION_MESSAGES[reason]}
    </Typography>
    <Typography component="span" display="block" variant="caption" sx={{ mt: 1 }}>
      {reason === 'concurrent_limit_reached'
        ? 'Wait for capacity to become available, then try again. Active calls can finish.'
        : 'Your current work stays open. Active calls can finish. Return here and retry when access is ready.'}
    </Typography>
    <Button
      component={Link}
      href={AuthenticatedPath.BILLING}
      target="_blank"
      rel="noopener noreferrer"
      size="small"
      sx={{ mt: 1, p: 0, textTransform: 'none' }}>
      View billing in a new tab
    </Button>
  </>
);
